import React from "react";
import { Typography as AntdTypography } from "antd";

const { Title: AntdTitle, Text: AntdText, Paragraph: AntdParagraph, Link: AntdLink } = AntdTypography;

export type TitleProps = React.ComponentProps<typeof AntdTitle>;
export type TextProps = React.ComponentProps<typeof AntdText>;
export type ParagraphProps = React.ComponentProps<typeof AntdParagraph>;
export type LinkProps = React.ComponentProps<typeof AntdLink>;

/**
 * Typography Title component
 */
export const Title: React.FC<TitleProps> = (props) => {
  return <AntdTitle {...props} />;
};

/**
 * Typography Text component
 */
export const Text: React.FC<TextProps> = (props) => {
  return <AntdText {...props} />;
};

/**
 * Typography Paragraph component
 */
export const Paragraph: React.FC<ParagraphProps> = (props) => {
  return <AntdParagraph {...props} />;
};

/**
 * Typography Link component
 */
export const Link: React.FC<LinkProps> = (props) => {
  return <AntdLink {...props} />;
};

/**
 * Typography namespace export for destructuring usage
 * Example: const { Title, Text } = Typography;
 */
export const Typography = {
  Title,
  Text,
  Paragraph,
  Link,
};

export default Typography;
